import type { SVGProps } from 'react'

/**
 * Symbol oficial da Westhetics — paths extraídos de `docs/design/assets/symbol-black.svg`.
 * Renderiza em `currentColor`: controle a cor com `text-ink`, `text-pampas` etc.
 * e o tamanho com a altura (`h-[13px] w-auto`). Nunca substitua por texto com letter-spacing.
 */
export function Symbol({
  title = 'Westhetics',
  pathLength,
  ...props
}: SVGProps<SVGSVGElement> & {
  title?: string
  /** Normaliza o comprimento do traço (ex.: 1) para animar o desenho com `stroke-dasharray`. */
  pathLength?: number
}) {
  return (
    <svg viewBox="0 0 1079.81 1002.78" fill="currentColor" role="img" aria-label={title} {...props}>
      <title>{title}</title>
      <path
        pathLength={pathLength}
        d="M761.36,893.51c-163.27,12.56,30.49-578.54-193.05-541.11-51.13,8.56-121.07,85.93-196.62,192.62-45.35,64.07-92.23,130.34-130.85,164.88-28.67,25.52-54.02,33.52-75.13,23.57C34.69,671.79,44.65,0,44.65,0c-5.02,33.78-119.79,829.53,39.65,932.05,28.5,18.29,63.55,14.29,104.22-12,53.52-34.54,111.11-115.54,166.93-193.9,58.54-82.36,119.76-145.93,151.87-157.74,137.78-50.68-1.91,396.16,172.46,431.86,146.82,30.06,297.13-216.67,400.05-437.14,0,0-195.56,320.91-318.45,330.36Z"
      />
    </svg>
  )
}
